import React from 'react';
import { BadgesGroup, Element, PackageAttributes, PriceContainer } from './PackageSummary.styles';
import { Text, Title } from '@/components/typography';
import Badge from '@/components/badge/Badge';
import { usePacoteDetailContext } from '@/features/pacote/PacoteDetail/context';
import TravelDetailList from '@/features/pacote/components/TravelDetailList/TravelDetailList';
import { TravelTypeIcon } from '@/features/pacote/PacotesList/components';
import { useTranslations } from 'next-intl';
import TagsBadgeList from '@/features/pacote/components/TagsBadgeList/TagsBadgeList';

const PackageSummary = () => {
  const t = useTranslations('Pacote');
  const { data } = usePacoteDetailContext();

  const { ...pacote } = data.page;

  return (
    <Element>
      <Title as="h3" size="lg" color="neutral_500" align="center" weight="light">
        {t('Resumo do Pacote')}
      </Title>
      <PriceContainer>
        {(pacote.travel_amount && (
          <Text as="span" weight="bold">
            {t('Preço a partir de')}
          </Text>
        )) || (
          <Text as="span" weight="bold">
            {t('Preço')}
          </Text>
        )}

        <Text as="span" size="xl" weight="bold">
          {(!pacote.travel_amount && (
            <Text as="small" size="md">
              {t('Sob Consulta')}
            </Text>
          )) || (
            <>
              <Text as="small" size="md">
                {pacote.travel_currency}
              </Text>{' '}
              {pacote.travel_amount}
              {(pacote.travel_currency !== 'BRL' && <sup>*</sup>) || null}
            </>
          )}
        </Text>
        {(pacote.travel_amount && (
          <Text size="xs" as="small" textCase="uppercase">
            {pacote.travel_amount_info}
          </Text>
        )) ||
          null}
      </PriceContainer>
      <BadgesGroup>
        <Badge size="sm" color="primary_500">
          <TravelTypeIcon id={pacote.travel_type.slug} width={16} color="white" />
          {pacote.travel_type.title}
        </Badge>
      </BadgesGroup>
      <TagsBadgeList tags={pacote.tags} />
      <PackageAttributes>
        <TravelDetailList {...pacote} />
      </PackageAttributes>
      <div>
        <Text weight="light" size="xs" color="neutral_600">
          * {t('Valor indicado em moeda estrangeira, convertido em reais de acordo com a cotação do dia do pagamento')}.
        </Text>
      </div>
    </Element>
  );
};

export default PackageSummary;
